import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { FormErrorsComponent } from '@shared/components/form-elements/form-errors/form-errors.component';
import { InputFieldComponent } from '@shared/components/form-elements/input-field/input-field.component';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';

@Component({
  selector: 'save-cart-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent,
    InputFieldComponent,
    FormErrorsComponent,
  ],
  templateUrl: './cart-save-modal.component.html',
  styleUrl: './cart-save-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartSaveModalComponent implements OnInit {
  control = new FormControl<string | null>(null, {
    validators: [Validators.required],
    updateOn: 'change',
  });
  cart = toSignal(this.cartService.getCart());

  constructor(
    private modalService: ModalService,
    private cartService: CartService,
  ) {}

  ngOnInit(): void {
    this.control.markAsTouched();
    this.control.updateValueAndValidity();
    this.control.setValue(this.cart()?.data?.name || null);
  }

  onCancel() {
    this.modalService.skip();
  }

  onSubmit(event: Event) {
    event.preventDefault();

    if (!this.control.valid || !this.control.value) {
      this.control.markAsTouched();
      return;
    }

    const cartName = this.control.value;
    const currentCart = this.cart()?.data;

    if (currentCart) {
      this.cartService
        .updateCart(cartName)
        .pipe(take(1))
        .subscribe(() => {
          this.cartService
            .createCart()
            .pipe(take(1))
            .subscribe(() => {
              this.modalService.skip();
            });
        });
    }
  }
}
